var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticClass: "container-content",
          staticStyle: { height: "48px", display: "flex" },
        },
        [
          _vm.titleFlag === "2"
            ? _c(
                "div",
                { staticStyle: { "margin-top": "10px", "font-size": "15px" } },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.$t("home.basicInfoPreviousVersion")) +
                      "\n    "
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.titleFlag === "3"
            ? _c(
                "div",
                { staticStyle: { "margin-top": "10px", "font-size": "15px" } },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.$t("home.basicInfoNextVersion")) +
                      "\n    "
                  ),
                ]
              )
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-form",
        {
          ref: "form",
          attrs: {
            inline: true,
            "label-position": "top",
            model: _vm.form,
            disabled: true,
          },
        },
        [
          _c("bookMaterialsMainInfo", {
            ref: "bookMaterialsMainInfo",
            attrs: {
              differentKeys: _vm.differentKeys,
              form: _vm.form,
              paidTypeList: _vm.paidTypeList,
              bookingTypeList: _vm.bookingTypeList,
              transportationTermsList: _vm.transportationTermsList,
            },
          }),
          _vm._v(" "),
          _c("bookMaterialsWebFeeItem", {
            ref: "bookMaterialsWebFeeItem",
            attrs: {
              paidTypeList: _vm.paidTypeList,
              titleFlag: _vm.titleFlag,
              form: _vm.form,
              height: 150,
              feeItemDiff: _vm.feeItemDiff,
            },
          }),
          _vm._v(" "),
          _c("bookMaterialsWebBkYard", {
            ref: "bookMaterialsWebBkYard",
            attrs: {
              titleFlag: _vm.titleFlag,
              form: _vm.form,
              height: 100,
              bkYardDiff: _vm.bkYardDiff,
            },
          }),
          _vm._v(" "),
          _c("bookMaterialsWebBkDocument", {
            ref: "bookMaterialsWebBkDocument",
            attrs: {
              packageTypeList: _vm.packageTypeList,
              titleFlag: _vm.titleFlag,
              form: _vm.form,
              height: 200,
              bkDocumentDiff: _vm.bkDocumentDiff,
            },
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { display: "flex", "justify-content": "center" } },
            [
              _c("consignerInfo", {
                ref: "consignerInfo",
                staticStyle: { width: "50%", "margin-right": "5px" },
                attrs: {
                  titleFlag: _vm.titleFlag,
                  consignerCheck: _vm.consignerCheck,
                  form: _vm.form,
                },
              }),
              _vm._v(" "),
              _c("consignerReceiveInfo", {
                ref: "consignerReceiveInfo",
                staticStyle: { width: "50%", "margin-left": "5px" },
                attrs: {
                  titleFlag: _vm.titleFlag,
                  consigneeCheck: _vm.consigneeCheck,
                  form: _vm.form,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { display: "flex", "justify-content": "center" } },
            [
              _c("consignerInfoOne", {
                ref: "consignerInfoOne",
                staticStyle: { width: "50%", "margin-right": "5px" },
                attrs: {
                  titleFlag: _vm.titleFlag,
                  notifierOneCheck: _vm.notifierOneCheck,
                  form: _vm.form,
                },
              }),
              _vm._v(" "),
              _c("consignerInfoTwo", {
                ref: "consignerInfoTwo",
                staticStyle: { width: "50%", "margin-left": "5px" },
                attrs: {
                  titleFlag: _vm.titleFlag,
                  notifierTwoCheck: _vm.notifierTwoCheck,
                  form: _vm.form,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("bookCargo", {
            ref: "bookCargo",
            attrs: {
              titleFlag: _vm.titleFlag,
              bkCargoDiff: _vm.bkCargoDiff,
              differentKeys: _vm.differentKeys,
              "show-cargo-info": true,
              formInfo: _vm.form,
            },
          }),
          _vm._v(" "),
          _c("dropTitle", {
            ref: "dropTitle",
            attrs: {
              rules: _vm.rules,
              titleFlag: _vm.titleFlag,
              bkPreContainerDiff: _vm.bkPreContainerDiff,
              form: _vm.form,
              containerTypeList: _vm.containerTypeList,
            },
          }),
          _vm._v(" "),
          _vm.form.pol
            ? _c("boxInfo", {
                ref: "boxInfo",
                attrs: {
                  rules: _vm.rules,
                  titleFlag: _vm.titleFlag,
                  bkContainerDiff: _vm.bkContainerDiff,
                  form: _vm.form,
                  containerTypeList: _vm.containerTypeList,
                  cargoList: _vm.cargoList,
                  directionList: _vm.directionList,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "filter-container-content" },
            [
              _c(
                "el-row",
                { attrs: { gutter: 14 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          class: [
                            {
                              reqired:
                                _vm.form.pol && _vm.form.pol.startsWith("KR"),
                            },
                            _vm.inputClass("remark"),
                          ],
                          attrs: {
                            prop: "remark",
                            label: _vm.$t("home.remark"),
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { maxlength: "100" },
                            model: {
                              value: _vm.form.remark,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "remark", $$v)
                              },
                              expression: "form.remark",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          class: _vm.inputClass("priceRemark"),
                          attrs: {
                            prop: "priceRemark",
                            label: _vm.$t("home.priceRemark"),
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { maxlength: "100" },
                            model: {
                              value: _vm.form.priceRemark,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "priceRemark", $$v)
                              },
                              expression: "form.priceRemark",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }